import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import { IMAGES } from "../../../assets/images/images";
import { Link, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  emailState,
  UseridState,
} from "../../../utility/globle/recoil/atom";
import {
  resendOtp,
  verifyOtp,
} from "../../../utility/apiServices/userServices";
import { setLocalStorage } from "../../../utility/local/functions/setlocalStorage";

const UserSignUpOTP = () => {
  const navigate = useNavigate();
  const id = useRecoilValue(UseridState);
  const email = useRecoilValue(emailState);

  useEffect(() => {
    if (!id || !email || id === "" || email === "") {
      navigate("/user-signup");
    }
  }, [id, email, navigate]);

  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [messageType, setmessageType] = useState(false);
  const [Loading, setLoading] = useState(false);

  const resendNewOtp = async () => {
    const resendOtpresponse = await resendOtp({ userId: id, email });
    if (resendOtpresponse?.status) {
      setmessageType("success");
      setMessage(resendOtpresponse?.message);
      setShowMessage(true);
    } else {
      setmessageType("error");
      setMessage(resendOtpresponse?.message);
      setShowMessage(true);
    }
  };

  const VerifyUserOtp = async () => {
    setLoading(true);
    console.log("VerifyOtp VerifyOtp:");
    if (otp.length == 6) {
      const verifyOtpresponse = await verifyOtp({ userId: id, otp });
      console.log("verifyOtpresponse :", verifyOtpresponse);
      if (verifyOtpresponse?.status) {
        setLocalStorage(
          verifyOtpresponse.accessToken,
          verifyOtpresponse.refreshToken,
          verifyOtpresponse?.user
        );
        navigate("/");
      } else {
        setmessageType("error");
        setMessage(verifyOtpresponse?.message);
        setShowMessage(true);
      }
    } else {
      setmessageType("error");
      setMessage("Enter Valid OTP");
      setShowMessage(true);
    }
    setLoading(false);
  };

  const [otp, setOtp] = useState("");
  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Form>
                <h1>Verify OTP</h1>
                <p className="para">
                  Enter the OTP sent to your registered email address
                </p>

                <div className="otpBox">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <div className="text-end">
                  <Link
                    className="forgotPassword textLineUnder"
                    onClick={resendNewOtp}
                  >
                    Resend OTP
                  </Link>
                </div>

                <div className="text-start">
                  {showMessage && (
                    <div
                      className={
                        messageType == "success"
                          ? "successMessage"
                          : "errorMessage"
                      }
                    >
                      {message}
                    </div>
                  )}
                </div>
                <Button
                  // as={Link}
                  // to="/propertyowner-resetpassword"
                  className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                  onClick={() => VerifyUserOtp()}
                  disabled={Loading}
                >
                  {Loading ? <span className="spinner"></span> : "Continue"}
                </Button>
                <p className="text-center">
                  Back To{" "}
                  <Link
                    to="/user-signup"
                    className="forgotPassword forgotPassword1"
                  >
                    Signup
                  </Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserSignUpOTP;
